<div class="spinners__box d-flex justify-content-center align-items-center"
     [ngClass]="extendedClass" >
  <div class="reverse-spinner" [ngClass]="{'contrast':showContrast}">
  </div>
</div>
<ng-content></ng-content>
